import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cc-zones',
  templateUrl: './zones.component.html',
  styleUrls: ['./zones.component.scss']
})
export class ZonesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
